import { useState } from 'react';
import WebApp from '@twa-dev/sdk';
import { recordPR } from '../lib/api.js';

interface Props {
  onBack: () => void;
}

interface PRRecord {
  date: string;
  exercise: string;
  weight: number;
  reps: number;
}

const SAMPLE_PRS: PRRecord[] = [
  { date: '2026-04-01', exercise: 'Wall Ball', weight: 9, reps: 50 },
  { date: '2026-04-15', exercise: 'Wall Ball', weight: 9, reps: 53 },
  { date: '2026-04-25', exercise: 'Wall Ball', weight: 9, reps: 55 },
];

export function PRChallenge({ onBack }: Props) {
  const [exercise, setExercise] = useState('Wall Ball');
  const [weight, setWeight] = useState(9);
  const [reps, setReps] = useState(0);

  const recent = SAMPLE_PRS.slice(-3);
  const max = Math.max(...recent.map((r) => r.reps), 1);

  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    setSubmitting(true);
    WebApp.HapticFeedback?.impactOccurred?.('light');
    const ok = await recordPR(exercise, weight, reps);
    setSubmitting(false);
    if (ok) {
      WebApp.HapticFeedback?.notificationOccurred?.('success');
      WebApp.showPopup({
        title: '🏆 PR 기록 저장',
        message: `${exercise} ${weight}kg × ${reps}회\n(Firestore에 저장 완료)`,
        buttons: [{ id: 'ok', type: 'default', text: '확인' }],
      });
      setReps(0);
    } else {
      WebApp.HapticFeedback?.notificationOccurred?.('error');
      WebApp.showAlert('저장 실패. 코치에게 알려주세요.');
    }
  }

  return (
    <div className="app">
      <button className="back-link" onClick={onBack}>← 홈</button>
      <h1>🏆 PR 도전</h1>

      <div style={{ marginTop: 16, marginBottom: 24 }}>
        <h3 style={{ fontSize: 14, color: 'var(--tg-hint)', marginBottom: 12 }}>최근 3회</h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 120, padding: 12, background: 'var(--tg-secondary)', borderRadius: 12 }}>
          {recent.map((r, i) => (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
              <strong style={{ fontSize: 14 }}>{r.reps}</strong>
              <div
                style={{
                  width: '100%',
                  height: `${(r.reps / max) * 80}px`,
                  background: 'var(--tg-button)',
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 0.4s ease',
                }}
              />
              <small style={{ fontSize: 10, color: 'var(--tg-hint)' }}>
                {r.date.slice(5)}
              </small>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <label style={{ display: 'block' }}>
          <small style={{ color: 'var(--tg-hint)' }}>종목</small>
          <input
            type="text"
            value={exercise}
            onChange={(e) => setExercise(e.target.value)}
            style={{
              display: 'block',
              width: '100%',
              padding: 12,
              borderRadius: 8,
              border: '1px solid var(--tg-secondary)',
              background: 'var(--tg-secondary)',
              color: 'var(--tg-text)',
              fontSize: 16,
              marginTop: 4,
            }}
          />
        </label>

        <label style={{ display: 'block' }}>
          <small style={{ color: 'var(--tg-hint)' }}>무게 (kg)</small>
          <input
            type="number"
            value={weight}
            onChange={(e) => setWeight(Number(e.target.value))}
            style={{
              display: 'block',
              width: '100%',
              padding: 12,
              borderRadius: 8,
              border: '1px solid var(--tg-secondary)',
              background: 'var(--tg-secondary)',
              color: 'var(--tg-text)',
              fontSize: 16,
              marginTop: 4,
            }}
          />
        </label>

        <label style={{ display: 'block' }}>
          <small style={{ color: 'var(--tg-hint)' }}>반복수</small>
          <input
            type="number"
            value={reps}
            onChange={(e) => setReps(Number(e.target.value))}
            style={{
              display: 'block',
              width: '100%',
              padding: 12,
              borderRadius: 8,
              border: '1px solid var(--tg-secondary)',
              background: 'var(--tg-secondary)',
              color: 'var(--tg-text)',
              fontSize: 16,
              marginTop: 4,
            }}
          />
        </label>

        <button className="btn" onClick={submit} disabled={reps === 0 || submitting}>
          {submitting ? '저장 중…' : '🚀 기록 저장'}
        </button>
      </div>
    </div>
  );
}
